import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import ReactDatePicker from 'react-datepicker';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import {
    ApiCourseLoadminimal,
    Appointment,
    Booking,
    BookingOption,
    CourseMinimal,
    CoursesLoadMinimalResult,
} from '../../api';
import { SelectInput } from '../cpProfileComponent/CPItemEditComponent';

interface TableBoxForNewParticipantState {
    appointment: string;
    appointmentArray: string[];
    bookingOption: string;
    bookingOptionArray: string[];
    bookingPrice: number;
    courseName: string;
    courseNameArray: string[];
    email: string;
    firstName: string;
    lastName: string;
    listData: CoursesLoadMinimalResult;
    telephon: string;
    saveBooking: Booking;
    type: string;
}

export interface TableBoxForNewParticipantProps {
    onClickSave: (saveBooking: Booking) => void;
}

export default class TableBoxForNewParticipant extends React.PureComponent<
    TableBoxForNewParticipantProps,
    TableBoxForNewParticipantState
> {
    constructor(props: TableBoxForNewParticipantProps) {
        super(props);
        this.state = {
            appointment: '',
            appointmentArray: [],
            bookingOption: '',
            bookingOptionArray: [],
            bookingPrice: 0,
            courseName: '',
            courseNameArray: [],
            email: '',
            firstName: '',
            lastName: '',
            listData: { Courses: [] },
            saveBooking: {
                Appointment: {},
                BookingOptionName: '',
                BookingOptionPrice: 0,
                City: '',
                Commission: 0,
                CommissionFee: 0,
                CourseID: '',
                CourseName: '',
                CourseProviderID: '',
                CourseProviderName: '',
                Email: '',
                FirstName: '',
                ID: '',
                InsertDate: {},
                LastName: '',
                Lecturer: '',
                Note: '',
                Reason: '',
                Rejected: false,
                State: '',
                Street: '',
                Telephone: '',
                UpdateDate: {},
                Zip: '',
            },
            telephon: '',
            type: '',
        };
    }

    public componentDidMount() {
        this.loadCourseLoadMinimal();
    }

    public render() {
        const { courseNameArray, saveBooking, appointmentArray, bookingOptionArray, type } = this.state;
        return (
            <>
                <Row>
                    <Col md={3} className="mb-1">
                        <Label>{TR.tableBoxForNewParticipant_course}</Label>
                        <SelectInput
                            bsSize={'sm'}
                            id={`CourseName`}
                            name="CourseName"
                            selectArr={courseNameArray}
                            value={this.state.courseName}
                            onChangeOption={(e: React.ChangeEvent<HTMLInputElement>) => {
                                this.calculatAnotherState(e.target.value);
                            }}
                        />
                    </Col>
                    <Col md={3} className="mb-1">
                        <Label>{TR.tableBoxForNewParticipant_appointment}</Label>
                        {type !== 'ondemand' && type !== 'selflearn' && type !== 'new' && (
                            <SelectInput
                                bsSize={'sm'}
                                id={`Appointment`}
                                name="Appointment"
                                selectArr={appointmentArray}
                                value={this.state.appointment}
                                onChangeOption={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    const mySaveBooking: Booking = saveBooking;
                                    this.state.listData.Courses.map((b: CourseMinimal) => {
                                        if (this.formatCoursename(b) === this.state.courseName) {
                                            b.Appointments.map((a: Appointment) => {
                                                if (this.formatAppointment(a) === e.target.value) {
                                                    mySaveBooking.Appointment = a.StartDate;
                                                }
                                            });
                                        }
                                    });
                                    this.setState({
                                        appointment: e.target.value,
                                        saveBooking: Object.assign(saveBooking, mySaveBooking),
                                    });
                                }}
                            />
                        )}
                        {type === 'ondemand' && (
                            <>
                                <br />
                                <ReactDatePicker
                                    selected={
                                        this.state.appointment && moment(this.state.appointment).isValid()
                                            ? moment(this.state.appointment)
                                            : null
                                    }
                                    placeholderText={'TT.MM.JJJJ'}
                                    onChange={(e: moment.Moment) => {
                                        this.setState({
                                            appointment: moment(e).toString(),
                                            saveBooking: {
                                                ...saveBooking,
                                                Appointment: e,
                                            },
                                        });
                                    }}
                                />
                            </>
                        )}
                    </Col>
                    <Col md={3} className="mb-1">
                        <Label>{TR.tableBoxForNewParticipant_bookingoption}</Label>
                        <SelectInput
                            bsSize={'sm'}
                            id={`bookingOptions`}
                            name="bookingOptions"
                            selectArr={bookingOptionArray}
                            value={this.state.bookingOption}
                            onChangeOption={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const mySaveBooking: Booking = saveBooking;
                                this.state.listData.Courses.map((b: CourseMinimal) => {
                                    const cname = this.state.courseName.replace(/\(.*\)/, '').trim();
                                    console.log('#' + cname + '# #' + b.Title + '#');
                                    if (b.Title === cname) {
                                        b.BookingOptions.map((a: BookingOption) => {
                                            if (a.Name === e.target.value) {
                                                mySaveBooking.BookingOptionName = a.Name;
                                                mySaveBooking.BookingOptionPrice = a.Price;
                                            }
                                        });
                                    }
                                });
                                this.setState({
                                    bookingOption: mySaveBooking.BookingOptionName,
                                    bookingPrice: mySaveBooking.BookingOptionPrice,
                                    saveBooking: Object.assign(saveBooking, mySaveBooking),
                                });
                            }}
                        />
                    </Col>
                    <Col md={3} className="mb-1">
                        <Label>{TR.tableBoxForNewParticipant_course_price}</Label>
                        <Input
                            bsSize={'sm'}
                            id={`Price`}
                            name="Price"
                            type="text"
                            value={this.formatBookingPrice(this.state.bookingPrice)}
                            readOnly={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={3} className="mb-1">
                        <Label>{TR.tableBoxForNewParticipant_first_name}</Label>
                        <Input
                            bsSize={'sm'}
                            id="firstName"
                            name="FirstName"
                            placeholder="Vorname"
                            type="text"
                            value={this.state.firstName}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={3} className="mb-1">
                        <Label>{TR.tableBoxForNewParticipant_last_name}</Label>
                        <Input
                            bsSize={'sm'}
                            id="lastName"
                            name="LastName"
                            placeholder="Nachname"
                            type="text"
                            value={this.state.lastName}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={3} className="mb-1">
                        <Label>{TR.tableBoxForNewParticipant_telephone}</Label>
                        <Input
                            bsSize={'sm'}
                            id="telephon"
                            name="Telephone"
                            placeholder="Telefon"
                            type="text"
                            value={this.state.telephon}
                            onChange={this.inputHandler}
                        />
                    </Col>
                    <Col md={3} className="mb-1">
                        <Label>{TR.tableBoxForNewParticipant_email}</Label>
                        <Input
                            bsSize={'sm'}
                            id="email"
                            name="Email"
                            placeholder="E-Mail"
                            type="text"
                            value={this.state.email}
                            onChange={this.inputHandler}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>{TR.tableBoxForNewParticipant_enter_bookings}</Col>
                </Row>
                <Row className="mt-3">
                    <Col md={4}>
                        <Button
                            disabled={this.state.firstName !== '' && this.state.lastName !== '' ? false : true}
                            style={
                                this.state.firstName !== '' && this.state.lastName !== ''
                                    ? undefined
                                    : { ...{ pointerEvents: 'none' } }
                            }
                            block={true}
                            size="sm"
                            color="danger"
                            onClick={() => {
                                this.props.onClickSave(saveBooking);
                                const cname = this.state.listData.Courses[0].Title.replace(/\(.*\)/, '').trim();
                                this.setState({
                                    appointment:
                                        this.state.type !== 'ondemand' &&
                                        this.state.type !== 'selflearn' &&
                                        this.state.type !== 'new'
                                            ? this.formatAppointment(this.state.listData.Courses[0].Appointments[0])
                                            : '',
                                    bookingOption: this.state.listData.Courses[0].BookingOptions[0].Name,
                                    bookingPrice: this.state.listData.Courses[0].BookingOptions[0].Price,
                                    courseName: cname,
                                    email: '',
                                    firstName: '',
                                    lastName: '',
                                    telephon: '',
                                });
                            }}
                        >
                            <span>{TR.tableBoxForNewParticipant_save}</span>
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }

    private inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const mySaveBooking: Booking = this.state.saveBooking;
        const id = 'saveBooking';
        mySaveBooking[e.target.name] = e.target.value;
        const newState = {};
        newState[e.target.id] = e.target.value.trim();
        newState[id] = mySaveBooking;
        this.setState(newState);
    };

    private formatAppointment = (a: Appointment) => {
        let start: string = '';
        let end: string = '';
        if (a.StartDate) {
            start = moment(a.StartDate).format('DD.MM.YYYY').toString();
        }
        if (a.EndDate) {
            end = moment(a.EndDate).format('DD.MM.YYYY').toString();
        }
        return start + ' - ' + end;
    };

    private formatBookingPrice(myBookingPrice: number): string {
        return (
            myBookingPrice.toLocaleString('de-DE', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                useGrouping: false,
            }) + ' €'
        );
    }

    private calculatAnotherState = (myCourseName: string) => {
        const newSaveBooking: Booking = this.state.saveBooking;
        const newBookingOptionsArray: string[] = [];
        const newAppointmentArray: string[] = [];
        this.state.listData.Courses.map((a: CourseMinimal) => {
            const formattedTitle = this.formatCoursename(a);
            if (formattedTitle === myCourseName) {
                newSaveBooking.CourseID = a.ID;
                newSaveBooking.CourseName = formattedTitle;
                a.BookingOptions.map((b: BookingOption) => {
                    newBookingOptionsArray.push(b.Name);
                });
                if (a.Type !== 'ondemand' && a.Type !== 'selflearn' && a.Type !== 'new') {
                    a.Appointments!.map((c: Appointment) => {
                        newAppointmentArray.push(this.formatAppointment(c));
                    });
                }

                newSaveBooking.Appointment =
                    a.Type !== 'ondemand' && a.Type !== 'new' && a.Appointments.length > 0
                        ? a.Appointments[0].StartDate
                        : a.Type === 'selflearn'
                        ? new Date()
                        : {};
                console.log(a, newSaveBooking);
                newSaveBooking.BookingOptionName = a.BookingOptions[0].Name;
                newSaveBooking.BookingOptionPrice = a.BookingOptions[0].Price;
                this.setState({
                    appointment: newAppointmentArray[0],
                    appointmentArray: newAppointmentArray,
                    bookingOption: newSaveBooking.BookingOptionName,
                    bookingOptionArray: newBookingOptionsArray,
                    bookingPrice: newSaveBooking.BookingOptionPrice,
                    courseName: newSaveBooking.CourseName,
                    saveBooking: Object.assign(this.state.saveBooking, newSaveBooking),
                    type: a.Type,
                });
            }
        });
    };

    private formatCoursename(c: CourseMinimal): string {
        let name = c.Title;
        if (c.Appointments && c.Appointments.length > 0) {
            name += ' (' + moment(c.Appointments[0].StartDate).format('DD.MM.YYYY') + ')';
        }

        return name;
    }

    private loadCourseLoadMinimal = () => {
        const newCourseNameArray: string[] = [];
        ApiCourseLoadminimal((sr) => {
            if (sr.OK && sr.Data !== null) {
                sr.Data!.Courses.map((d: CourseMinimal) => {
                    newCourseNameArray.push(this.formatCoursename(d));
                });
                this.setState({ courseNameArray: newCourseNameArray, listData: sr.Data! }, () => {
                    this.calculatAnotherState(newCourseNameArray[0]);
                });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/cpBookingRequests/TableBoxForNewParticipant.tsx